module.exports = __webpack_public_path__ + "img/399-a111d5.png";